/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Reviews_Toast_UpdatedInputs */

const he_account_reviews_toast_updated = /** @type {(inputs: Account_Reviews_Toast_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הביקורת עודכנה`)
};

const en_account_reviews_toast_updated = /** @type {(inputs: Account_Reviews_Toast_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review updated`)
};

/**
* | output |
* | --- |
* | "Review updated" |
*
* @param {Account_Reviews_Toast_UpdatedInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_reviews_toast_updated = /** @type {((inputs?: Account_Reviews_Toast_UpdatedInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Reviews_Toast_UpdatedInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_reviews_toast_updated(inputs)
	return en_account_reviews_toast_updated(inputs)
});